import React, { useMemo, useCallback } from "react";
import { ChevronDown as ArrowDown } from "react-feather";
import { useDropdown } from "../../hooks/useDropdown";
import SortItem from "./sortItem";
import classes from "./productSort.module.css";

const ProductSort = (props) => {
  const { availableSortMethods, sortProps } = props;
  const [currentSort, setSort] = sortProps;
  const { elementRef, expanded, setExpanded } = useDropdown();

  const handleItemClick = useCallback(
    (sortAttribute) => {
      setSort({
        sortText: sortAttribute.text,
        sortId: sortAttribute.id,
        sortAttribute: sortAttribute.attribute,
        sortDirection: sortAttribute.sortDirection,
      });
      setExpanded(false);
    },
    [setExpanded, setSort]
  );

  const sortElements = useMemo(() => {
    if (!expanded) {
      return null;
    }

    const itemElements = Array.from(availableSortMethods, (sortItem) => {
      const { attribute, sortDirection } = sortItem;
      const isActive =
        currentSort.sortAttribute === attribute &&
        currentSort.sortDirection === sortDirection;

      const key = `${attribute}--${sortDirection}`;
      return (
        <li key={key} className={classes.menuItem}>
          <SortItem
            sortItem={sortItem}
            active={isActive}
            onClick={handleItemClick}
          />
        </li>
      );
    });

    return (
      <div className={classes.menu}>
        <ul className={classes.menuList}>{itemElements}</ul>
      </div>
    );
  }, [
    availableSortMethods,
    classes.menu,
    classes.menuItem,
    currentSort.sortAttribute,
    currentSort.sortDirection,
    expanded,
    handleItemClick,
  ]);

  const handleSortClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div
      ref={elementRef}
      className={classes.root}
      aria-live="polite"
      aria-busy="false"
    >
      <button
        priority={"low"}
        className={`btn ${classes.button} btn-transparent dropdown-toggle body-clr p-0 py-1 sm-font fw-400 sort-toggle`}
        onClick={handleSortClick}
      >
        <span className={classes.mobileText}>
          <span>Sort</span>
        </span>
        <span className={classes.desktopText}>
          <h6 className={classes.sortText}>
            <span>Sort by</span>
            &nbsp;{currentSort.sortText}
          </h6>
        </span>
      </button>
      {sortElements}
    </div>
  );
};

ProductSort.defaultProps = {
  availableSortMethods: [
    {
      text: "Position",
      id: "sortItem.position",
      attribute: "position",
      sortDirection: "ASC",
    },
    {
      id: "sortItem.relevance",
      text: "Best Match",
      attribute: "relevance",
      sortDirection: "DESC",
    },
    {
      id: "sortItem.priceAsc",
      text: "Price: Low to High",
      attribute: "price",
      sortDirection: "ASC",
    },
    {
      id: "sortItem.priceDesc",
      text: "Price: High to Low",
      attribute: "price",
      sortDirection: "DESC",
    },
  ],
};

export default ProductSort;
